(function (cao, $) {
    cao.PreviewIcon = function () {
        $("[data-input-icon]").change(function () {
            $("[data-preview-icon]").removeClass()
            $("[data-preview-icon]").addClass(this.value);
        });
    }

    cao.SaveShortcutsTableOrder = function () {
        if ($('#shortcutsTable tbody tr[data-rowaltered]').length > 0) {
            var json = [];
            $('#shortcutsTable tbody tr').each((row_index, row) => {
                json.push({ Key: $(row).attr('id'), Order: row_index });
            });

            $.ajax({
                type: "POST",
                contentType: "application/json",
                url: "/Cao/Shortcuts/ReorderShortcuts",
                cache: false,
                data: JSON.stringify(json),
                complete: function (result) {
                    globalCore.ShowAlert(result.responseJSON.success, "#sync-alert-container-shortcuts", "De snelkoppelingen zijn opgeslagen.", "Het opslaan van de snelkoppelingen is mislukt.")
                    if (result.responseJSON.success) {
                        $('#shortcutsTable tbody tr').each((row_index, row) => {
                            $(row).removeAttr('data-rowaltered');
                        });
                    }
                }
            });
        }
    }

    cao.SaveModulesTableOrder = function () {
        if ($('#modulesTable tbody tr[data-rowaltered]').length > 0) {
            var json = [];
            $('#modulesTable tbody tr').each((row_index, row) => {
                json.push({ Key: $(row).attr('id'), Order: row_index });
            });

            $.ajax({
                type: "POST",
                contentType: "application/json",
                url: "/Cao/Modules/ReorderModules",
                cache: false,
                data: JSON.stringify(json),
                complete: function (result) {
                    globalCore.ShowAlert(result.responseJSON.success, "#sync-alert-container-modules", "De modules zijn opgeslagen.", "Het opslaan van de modules is mislukt.")
                    if (result.responseJSON.success) {
                        $('#modulesTable tbody tr').each((row_index, row) => {
                            $(row).removeAttr('data-rowaltered');
                        });
                    }
                }
            });
        }
    }

    /* Synchronise modules with Profit  */
    cao.SynchronizeModulesWithProfit = function () {
        var button = $("[data-synchronize-modules]");
        var data = {
            customerKey: $('[data-customer-key]').val(),
        };

        globalCore.ShowButtonSpinner(button);
        $.ajax({
            url: "/Cao/Modules/SynchronizeModulesWithProfit",
            dataType: "json",
            data: data,
            complete: function (data) {
                rap.ReloadSubscriptionStatus();
                globalCore.HideButtonSpinner(button);
                globalCore.ShowAlert(data.responseJSON.success, "#sync-alert-container-modules", "Geabonneerde modules succesvol bijgewerkt.", "Het synchroniseren van een of meer abonnementen is mislukt.");
            }
        });
    }

    /* Add Select2 to ProfitCodes select field*/
    cao.AddSelectProfitCodes = function (selectedAttribute) {

        $.fn.select2.amd.require(['select2/selection/search'], function (Search) {
            var oldRemoveChoice = Search.prototype.searchRemoveChoice;

            Search.prototype.searchRemoveChoice = function () {
                oldRemoveChoice.apply(this, arguments);
                this.$search.val('');
            };

            $(selectedAttribute).select2({
                theme: "bootstrap-5",
                dropdownParent: $('#modalcontainer'),
                language: "nl"
            });
        });
    }

    /* Submit the form data */
    cao.discourseSet = function (model) {
        $.ajax({
            url: "/Cao/DiscourseCategories/Set",
            method: "POST",
            data: model.serializeArray(),
            success: function (response) {
                globalCore.ShowAlert(true, "#sync-alert-discourse-category", "Discourse instellingen opgeslagen.", "");
                $('#discourseCategoryForm').html(response);
            },
            error: function (response) {
                globalCore.ShowAlert(false, "#sync-alert-discourse-category", "", response.responseJSON.value.message);
            }
        });
    }

    /* Show success message and refresh the component view */
    cao.discourseSynchronize = function (response) {
        globalCore.ShowAlert(true, "#sync-alert-discourse-category", "Discourse is gesynchroniseerd.", "");
        $('#discourseCategoryComponent').html(response);
    }

    /* Show an error message */
    cao.discourseSynchronizeShowAlert = function (response) {
        globalCore.ShowAlert(false, "#sync-alert-discourse-category", "Discourse is gesynchroniseerd.", response.responseJSON.value.message);
    }

    cao.InitCaoGrid = function (userIsAdmin) {
        $('#caosGrid').DataTable(datatable.defaultDataTableOptions({
            ajax: {
                url: `/Cao/ListPaged`
            },
            columns: [
                { data: "name", name: "Name", title: "Naam", orderable: true, searchable: true },
                { responsivePriority: -1, defaultContent: "", orderable: false, searchable: false }
            ],
            columnDefs: [
                {
                    targets: 0,
                    width: '100%',
                    className: 'text-truncate'
                },
                {
                    targets: -1,
                    width: '100px',
                    className: 'text-end text-nowrap',
                    fixed: true,
                    render: function (data, type, full, meta) {
                        return `<a asp-action="Delete" asp-route-key="@full.key" class="btn btn-datatable btn-outline-primary fas fa-trash-alt ${!userIsAdmin ? 'disabled' : ''}" title="Verwijderen" href="/Cao/Delete?key=${globalCore.urlEncode(full.key)}"></a>
                        <a asp-action="Edit" asp-route-key="@full.key" class="btn btn-datatable btn-outline-primary fas fa-edit" title="Wijzigen" href="/Cao/Edit?key=${globalCore.urlEncode(full.key)}"></a>`;
                    }
                }
            ]
        }));
    }

    cao.InitCaoChecklistItemGrid = function (caoKey) {
        $('#checklistItemsgrid').DataTable(datatable.defaultDataTableOptions({
            ajax: {
                url: `/Cao/ChecklistItemsGrid?caoKey=${caoKey}`
            },
            columns: [
                { data: "name", name: "Name", title: "Naam", orderable: true, searchable: true },
                { data: "type", name: "Type", title: "Type", enum: enums.checkCategoryType, orderable: true, searchable: true },
                { responsivePriority: -1, defaultContent: "", orderable: false, searchable: false }
            ],
            columnDefs: [
                {
                    targets: [0, 1],
                    width: '50%',
                    className: 'text-truncate'
                },
                {
                    targets: -1,
                    width: '100px',
                    className: 'text-end text-nowrap',
                    fixed: true,
                    render: function (data, type, full, meta) {
                        return `<a asp-action="Delete" asp-route-key="@full.key" data-bs-toggle="modal" data-bs-target="#modalcontainer" class="btn btn-datatable btn-outline-primary fas fa-trash-alt" title="Verwijderen" href="/Cao/DeleteChecklistItemPartial?key=${globalCore.urlEncode(full.key)}"></a>
                        <a asp-action="Edit" asp-route-key="@full.key" data-bs-toggle="modal" data-bs-target="#modalcontainer" class="btn btn-datatable btn-outline-primary fas fa-edit" title="Wijzigen" href="/Cao/UpdateChecklistItemPartial?key=${globalCore.urlEncode(full.key)}"></a>`;
                    }
                }
            ]
        }));
    }
}(window.cao = window.cao || {}, $));
